import { Route } from 'react-router-dom';
import { NewPassword } from './NewPassword/NewPassword';
import { PasswordRecover } from './PasswordRecover/PasswordRecover';
import { SignIn } from './SignIn/SignIn';
import { SignUp } from './SignUp/SignUp';
import { VerificationCode } from './VerificationCode/VerificationCode';

// Rotas de autenticação, renderizadas dentro do layout <Login /> (via <Outlet />).
const authRoutes = (
	<>
		<Route path="/login" element={<SignIn />} />
		<Route path="/password-recover" element={<PasswordRecover />} />
		<Route path="/new-password" element={<NewPassword />} />
		<Route path="/register" element={<SignUp />} />
		<Route path="/verification-code" element={<VerificationCode />} />
	</>
);

export { authRoutes };
